'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DropdownMenu = require('react-bootstrap/lib/DropdownMenu');

var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DropdownMenu2.default;